<template>
<div class="border-outside">
    <div class="">
        <h1 class="font-title">非アクティブユーザーの請求書発行 </h1>
        <div class="desc-flex">
            <span class="font-desc">社員番号</span>
            <input type="text" v-model="inactiveUserId" class="date-input" />
            <button @click="goToInactiveUser" class="select-button">
                進める
            </button>
        </div>
    </div>
</div>
</template>

<script lang="ts">
import {defineComponent, ref} from "vue";
import { useRouter } from "vue-router";
import {loadingOverlayStateStore} from "@/stores/loading-overlay-state-store";
import {subPaths} from "@/utils/consts";

export default defineComponent({
    name: "InactiveUser",
    setup() {

        const inactiveUserId = ref<string>("")

        const router = useRouter()

        const goToInactiveUser = () => {
            loadingOverlayStateStore.commit("switchLoadingState", {
                show: true,
                message: "に移動中…"
            })

            router.push({
                path: subPaths.MY_PAGE_INVOICE_RESEND,
                query: {
                    "staff_id": inactiveUserId.value,
                    "path_for": "inactive"
                }
            })
        }

        return {
            goToInactiveUser,
            inactiveUserId
        }
    }
})
</script>

<style scoped lang="scss">
.border-outside {
    border: 2px solid lightgray;
    border-radius: 5px;
    display: flex;
    width: 100%;
    flex-direction: column;
}
.font-title {
    font-weight: 700;
    font-size: 32px;
    margin-bottom: 12px;
    margin-top: 20px;
}
.desc-flex {
    display: flex;
    gap: 12px;
    align-items: center;
    padding: 12px;
    margin-left: 20px;
}
.font-desc {
    font-weight: 400;
    font-size: 20px;
}
.select-button {
    background-color: #838383;
    color: white;
    border-radius: 8px;
    padding: 10px;
    border: none;
    width: 178px;
}
.date-input {
    height: 41px;
    width: 178px;
    background-color: #EBEBEB;
    padding: 10px 12px;
    border-radius: 8px;
    border: none;
}
.loading-flex {
    display: flex;
    flex-direction: column;
    justify-content: left;
    padding: 16px;
    margin: 12px 20px;
    border: 1px solid #9F9F9F;
    border-radius: 8px;
    gap: 8px;
}
.loading-title {
    display: flex;
    font-size: 20px;
    font-weight: 400;
    gap: 27px;
    align-items: center;

    .progress-text {
        font-size: 24px;
        font-weight: 700;
        color: #FF8C00;
    }
}

.donwload-desc {
    display: flex; 
    flex-direction: column;
    gap: 8px;
    font-size: 20px;

    .donwload-size-title {
        color: #9F9F9F;
    }

    .donwload-href {
        color: #294199;
        text-decoration: underline;
        font-weight: 600;
        text-align: left;
    }
}

progress {
    border-radius: 7px;
    height: 8px;
    width: 100%;
}
progress::-webkit-progress-bar {
    background-color: #CBCBCB;
    border-radius: 8px;
}
progress::-webkit-progress-value {
    background-color: #FF8C00;
    border-radius: 8px;
}

.donwload-flex {
    display: flex;
    padding: 16px;
    margin: 12px 20px;
    border: 1px solid #9F9F9F;
    border-radius: 8px;
    justify-content: space-between;
    align-items: center;
}

.circle-grey {
    width: 50px;
    height: 50px;
    background-color: #F1F1F1;
    border-radius: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}
</style>